import React, { useEffect } from "react";

const SimpleFieldInput = ({
  inputRef,
  field,
  inputType,
  inputLength,
  onEnter,
  value,
  onInputChange,
  action,
  fields,
  allowSpaces,
  fromModal,
}) => {
  return (
    <div
      className="divRow"
      style={{
        justifyContent: "center",
        width: inputLength > 50 ? "80%" : inputLength > 10 ? "50%" : "10%",
      }}
    >
      {((action == "Open" &&
        (field == "shortDescription" || field == "name")) ||
        (fromModal && field == "plural")) && (
        <div
          className="divRow"
          style={{
            fontFamily: "Roboto-Bold",
            marginTop: "5px",
            height: "20px",
            fontSize: "20px",
            color: "#bfbfbf",
            borderRadius: ".2rem/.2rem",
            backgroundColor: "#2f2f2f",
            textAlign: "center",
            padding: "5px",
          }}
        >
          {value}
        </div>
      )}
      {(action != "Open" || field == "longDescription") &&
        (!fromModal || field != "plural") && (
          <input
            onKeyDown={onEnter}
            maxLength={inputLength}
            ref={inputRef}
            value={value}
            type={inputType}
            onChange={(e) => {
              onInputChange(
                allowSpaces
                  ? e.target.value.replace(/[^a-z\s?!.,]/gi, "")
                  : e.target.value.replace(/[^a-z]/gi, ""),
                fields ?? field
              );
            }}
            style={{
              width: "100%",
              fontFamily: "Roboto-Bold",
              marginTop: "5px",
              height: "20px",
              fontSize: "20px",
              backgroundColor: "#e3e3e3",
              textAlign: "center",
            }}
          />
        )}
    </div>
  );
};

export default SimpleFieldInput;
